<template>
  <div class="losscustomerManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-invalidCustomer">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">{{ $t("Losscustomermanage.aa") }}</span>
              <div class="pull-right">
                <el-button type="primary" @click="daochu">
                  {{ $t("Common.btn_export") }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="losscustomerManage-container">
            <div class="content content-special">
              <div
                class="content-nav--head text-1 Tab-nav-head"
                v-if="postbe_crmlevel == '1'"
              >
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': item.id == currentIndex }"
                      @click="changeFilter(item)"
                    >
                     <span class="tag-label">
                      {{ item.label }}
                    
                      <span class="tag-num" v-if="item.value">{{
                        item.value
                      }}</span>
                    </span> 
                    </li>
                  </ul>
                </div>
              </div>

              <!-- <div v-if="postbe_crmlevel=='1'" class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item,index) in filtersOption"
                      :key="index"
                      :class="{'link-active':index==current}"
                      @click="addClass(index)"
                    >{{item}}</li>
                  </ul>
                </div>
                <div class="c-n--head_rt"></div>
              </div>-->
              <div
                class="content-nav--head text-1"
                :class="{ mt20: postbe_crmlevel != '1' }"
              >
                <!-- <div class="c-n--head_lf">
                  <span class="mr10">{{$t('views.Losscustomermanage.invalidCustomer.5zlnzspy3980')}}</span>
                </div>-->
                <div class="">
                  <div class="flex flex-wrap" v-if="!buttonHide">
                    <div class="flex-al mb10 mr10">
                      <span class="mr10 fs14 color-666">
                        无效时间:
                      </span>
                      <div class="time-box">
                        <el-date-picker
                          v-model="selectForm.invaTime"
                          type="daterange"
                          style="width: 260px"
                          :range-separator="$t('Common.to')"
                          value-format="yyyy-MM-dd"
                          :start-placeholder="$t('Common.startTime')"
                          :end-placeholder="$t('Common.endTime')"
                          @change="handleSelect()"
                        ></el-date-picker>
                      </div>
                    </div>
                    <div class="flex-al mb10 mr10">
                      <span class="mr10 fs14 color-666">
                        {{ $t("Losscustomermanage.ba") }}:
                      </span>
                      <div class="time-box">
                        <el-date-picker
                          v-model="selectForm.rangeTime"
                          type="daterange"
                          style="width: 260px"
                          :range-separator="$t('Common.to')"
                          value-format="yyyy-MM-dd"
                          :start-placeholder="$t('Common.startTime')"
                          :end-placeholder="$t('Common.endTime')"
                          @change="handleSelect()"
                        ></el-date-picker>
                      </div>
                    </div>
                    <div class="flex-al mb10 mr10">
                      <span class="mr10 fs14 color-666">
                        {{ $t("Losscustomermanage.bb") }}:
                      </span>
                      <div class="rate-box flex-al">
                        <el-rate
                          v-model="selectForm.client_intention_maxlevel"
                          @change="handleSelectLevel()"
                          class="client-level-rate level-rate-fliter"
                          :icon-classes="[
                            'crm-likes',
                            'crm-likes',
                            'crm-likes',
                          ]"
                          void-icon-class="crm-like"
                          :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                        ></el-rate>
                      </div>
                    </div>
                    <div class="flex-al mb10 mr10">
                      <el-select
                        filterable
                        clearable
                        v-model="selectForm.source"
                        style="width: 180px"
                        :placeholder="$t('Losscustomermanage.ac')"
                        @change="handleSelect()"
                      >
                        <el-option
                          v-for="item in SchoolsourceOption"
                          :key="item.frommedia_id"
                          :label="item.frommedia_name"
                          :value="item.frommedia_name"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="flex-al mb10 mr10">
                      <el-select
                        filterable
                        v-model="selectForm.invalidnote_code"
                        style="width: 180px"
                        clearable
                        :placeholder="$t('views.Losscustomermanage.invalidCustomer.69z8v9kfx7g0')"
                        @change="handleSelect()"
                      >
                        <el-option
                          v-for="items in selectForm.invalidNoteList"
                          :key="items.invalidnote_code"
                          :label="items.invalidnote_reason"
                          :value="items.invalidnote_code"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="flex-al mb10 mr10">
                      <el-select
                        filterable
                        v-model="selectForm.ishaveaudition"
                        style="width: 180px"
                        clearable
                        :placeholder="$t('Losscustomermanage.bc')"
                        @change="handleSelect()"
                      >
                        <el-option :label="$t('views.Losscustomermanage.invalidCustomer.69z8v9kfxwk0')" value="1"></el-option>
                        <el-option :label="$t('views.Losscustomermanage.invalidCustomer.69z8v9kfy280')" value="0"></el-option>
                      </el-select>
                    </div>
                    <div class="flex-al mb10">
                      <el-input
                        style="width: 220px"
                        clearable
                        :placeholder="$t('views.Losscustomermanage.invalidCustomer.69z8v9kfy680')"
                        class="input-cont"
                        @change="handleSelectKeyword()"
                        v-model="selectForm.keyword"
                      ></el-input>
                      <el-button
                        type="primary"
                        class="btn-inquire"
                        @click="handleSelectKeyword()"
                      >
                        {{ $t("Losscustomermanage.ae") }}
                      </el-button>
                    </div>
                  </div>
                  <!-- <template v-if="!buttonHide">
                    <div class="head-right">
                      <el-select
                        filterable
                        v-model="selectForm.source"
                        class="mr15"
                        style="width: 180px"
                        clearable
                        :placeholder="$t('Losscustomermanage.ac')"
                        @change="handleSelect"
                      >
                        <el-option
                          v-for="item in SchoolsourceOption"
                          :key="item.frommedia_id"
                          :label="item.frommedia_name"
                          :value="item.frommedia_name"
                        ></el-option>
                      </el-select>
                    </div>
                    <el-input
                      clearable
                      :placeholder="$t('Losscustomermanage.ad')"
                      class="input-cont"
                      @change="handleSelectKeyword()"
                      v-model="selectForm.keyword"
                    ></el-input>
                    <el-button
                      type="primary"
                      class="btn-inquire"
                      @click="handleSelectKeyword()"
                    >
                      {{ $t("Losscustomermanage.ae") }}
                    </el-button>
                  </template> -->
                  <template v-if="buttonHide && postbe_crmlevel == '1'">
                    <el-button type="primary" @click="changeLossClientData()">
                      {{ $t("Losscustomermanage.af") }}
                    </el-button>
                    <el-button
                      type="primary"
                      @click="changeLossIntentionData()"
                    >
                      {{ $t("Losscustomermanage.at") }}
                    </el-button>
                    <el-button type="primary" @click="visible = true">
                      {{
                        $t(
                          "views.Losscustomermanage.invalidCustomer.5zlnzspy4c40"
                        )
                      }}
                    </el-button>
                    <el-button
                      type="primary"
                      v-if="currentIndex == 1"
                      @click="changeSchoolVisible = true"
                    >
                      {{
                        $t(
                          "views.Losscustomermanage.invalidCustomer.5zlnzspy4gw0"
                        )
                      }}
                    </el-button>
                  </template>
                </div>
              </div>

              <div ref="auto_height_table">
                <TableList
                  v-if="currentIndex == 0"
                  :list="tableData"
                  :options="optionscaozuo"
                  :columns="columns"
                  :operates="operates"
                  @handleSelectionChange="handleSelectionChange"
                  @handleColumnChange="handleColumnChange"
                  :issetting="true"
                  :tableOperate="tableOperate"
                  @toggleEditableColumn="toggleEditableColumn"
                ></TableList>
                <TableList
                  v-if="currentIndex == 1"
                  :list="tableData"
                  :options="optionscaozuo"
                  :columns="columns"
                  :operates="operates1"
                  @handleSelectionChange="handleSelectionChange"
                  @handleColumnChange="handleColumnChange"
                  :issetting="true"
                  :tableOperate="tableOperate"
                  @toggleEditableColumn="toggleEditableColumn"
                ></TableList>

                <el-pagination
                  style="margin-top: 35px"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="dataNumber"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :isshowfirst="true"
        :isForm="true"
        :isHome="true"
        :isnotBiding="true"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @updateList="updateList"
      ></userSeeing>
    </SliderBox>
    <!-- 审核 -->
    <el-dialog
      :title="$t('Losscustomermanage.au')"
      :visible.sync="ReviewVisible"
      width="500px"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">
          <span>{{$t('views.Losscustomermanage.invalidCustomer.69z8v9kfyag0')}}</span>
          <span class="color-blue">{{ rowData.client_cnname }}</span>
          <span>{{$t('views.Losscustomermanage.invalidCustomer.69z8v9kfyeo0')}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ReviewVisible = false">{{
          $t("Losscustomermanage.ah")
        }}</el-button>
        <el-button type="primary" @click="lossInvalidExamineAction()">{{
          $t("Losscustomermanage.ai")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('views.Losscustomermanage.invalidCustomer.5zlnzspy4js0')"
      :visible.sync="visible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">
          {{ $t("views.Losscustomermanage.invalidCustomer.5zlnzspy4mw0") }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="changeLossClientTmkApi">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('views.Losscustomermanage.invalidCustomer.5zlnzspy4gw0')"
      :visible.sync="changeSchoolVisible"
      width="550px"
      :before-close="handleClose"
      v-if="changeSchoolVisible"
    >
      <el-form
        label-width="110px"
        :model="changeSchoolFormData"
        ref="changeSchoolForm"
      >
        <p style="padding: 0 0 20px 50px">
          <span>{{
            $t("views.Losscustomermanage.invalidCustomer.5zlo3fgl1u80")
          }}</span>
          <span style="color: #20a8d8">{{ MultipleClues.length }}</span>
        </p>
        <el-form-item
          :label="$t('views.Losscustomermanage.invalidCustomer.5zlnzspy4ps0')"
          prop="school_id"
          :rules="[
            {
              required: true,
              message: $t(
                'views.Losscustomermanage.invalidCustomer.5zlnzspy4ss0'
              ),
            },
          ]"
        >
          <el-select
            v-model="changeSchoolFormData.school_id"
            style="width: 320px"
            :placeholder="
              $t('views.Losscustomermanage.invalidCustomer.5zlnzspy4ss0')
            "
            clearable
            filterable
          >
            <el-option
              v-for="item in changeSchoolFormData.schoolList"
              :key="item.school_id"
              :label="item.school_cnname"
              :value="item.school_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="$t('views.Losscustomermanage.invalidCustomer.5zlnzspy4vs0')"
          prop="reason"
        >
          <el-input
            v-model="changeSchoolFormData.reason"
            style="width: 320px"
            :placeholder="
              $t('views.Losscustomermanage.invalidCustomer.5zlnzspy4yg0')
            "
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeSchoolVisible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="handleChangeSchool">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('Admissioncue.dy')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[$t('Admissioncue.bo'), $t('Admissioncue.bp')]"
        v-model="oprateColumn"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate">
          {{ $t("Admissioncue.ax") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
// import echarts from "echarts";
import SliderBox from "../../components/SliderBox";
import TableList from "../../components/Table/table.vue";
import userSeeing from "../../components/User/seeing.vue";
import storeLosscustomerManage from "./losscustomerManage.js";
import storeInvitationauditionmanage from "../Invitationauditionmanage/Invitationauditionmanage.js";
import storeAdmissionCue from "@/views/Admissioncue/admissionCue.js";
export default {
  name: "losscustomerManage-losscustomerManage",
  data() {
    return {
      rowData: {},
      currentIndex: 0,
      filtersOption: [
        { label: this.$t('views.Losscustomermanage.invalidCustomer.69z8v9kfyic0'), value: "", id: 0 },
        { label: this.$t('views.Losscustomermanage.invalidCustomer.69z8v9kfym40'), value: "", id: 1 },
      ],

      changeSchoolVisible: false,
      changeSchoolFormData: {
        schoolList: [],
        school_id: "",
        reason: "",
      },

      settingVisible: false,
      data: [],
      oprateColumn: [1, 4],

      openMenu: ["6"],
      showSliderBox: false,
      visible: false,
      showSliderBoxSee: false,
      leaningVisible: false,
      createJG: false,
      ReviewVisible: false, //是否审核
      seeSliderTitle: this.$t('views.Losscustomermanage.invalidCustomer.69z8v9kfyr40'),
      clientLevelNum: "", //存储意向星级数目
      ClassMessage: {}, //选择的试听班级
      inviteInfor: [],
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,
      current: 0,
      // filtersOption: [
      //   this.$t("Losscustomermanage.ak"),
      //   this.$t("Losscustomermanage.al"),
      // ],
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配

      fullscreenLoading: true, //全屏loading
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      selectForm: {
        invalidNoteList: [],
        rangeTime: "",
        invaTime: "",
        level: null,
        source: "",
        invalidnote_code: "",
        keyword: "",
      },
      //多条线索信息
      MultipleClues: [],
      // 招生渠道类型
      SchoolsourceOption: [],
      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      activeName: "first",
      buttonHide: false,
      // 侧边栏 资料建档

      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: true, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: "0", //表格高度
        errortip: "",
        // specialColumns:true//特殊列
      },
      columns: [],
      operates: {
        width: 150,
        label: this.$t("Losscustomermanage.am"),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t('views.Losscustomermanage.invalidCustomer.69z8v9kfzcg0'),
            type: "text",
            show: true,
            plain: true,
            ischaserlapsed: true,
            disabled: false,
            method: (index, row) => {
              this.customerId = row.client_id;
              this.rowData = row;
              this.ReviewVisible = true;
            },
          },
        ],
      }, // 列操作按钮
      operates1: {
        width: 150,
        label: this.$t("Losscustomermanage.am"),
        align: "center",
        fixed: "right",
        list: [],
      },
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {
    PageNav,
    SliderBox,
    userSeeing,
    TableList,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.getInvalidnoteApi();
    this.getSource();
  },
  mounted() {
    if (this.postbe_crmlevel == "1") {
      this.currentIndex = 0;
    } else {
      this.currentIndex = 1;
      this.optionscaozuo.mutiSelect = false;
    }
    this.getInvalidClientList();
    this.getAllSchoolApi();
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 95
        );
      }
    });
  },
  methods: {
    handClickOprate() {
      let allnum = JSON.parse(
        localStorage.getItem(`getInvalidClientList${this.current}`)
      );
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage(
        `showGetInvalidClientListColumns${this.current}`,
        this.showColumns
      );
      this.settingVisible = false;
      this.getInvalidClientList();
    },
    toggleEditableColumn() {
      this.settingVisible = !this.settingVisible;
    },
    getInvalidnoteApi() {
      this.$http.getInvalidnoteApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.selectForm.invalidNoteList = data.list;
        } else {
          this.selectForm.invalidNoteList = [];
        }
      });
    },
    changeFilter(item) {
      this.currentIndex = item.id;
      this.getInvalidClientList();
    },
    handleSelectLevel() {
      if (this.clientLevelNum == this.selectForm.client_intention_maxlevel) {
        this.selectForm.client_intention_maxlevel = null;
        this.clientLevelNum = "";
      } else {
        this.clientLevelNum = this.selectForm.client_intention_maxlevel;
      }
      this.handleSelect();
    },
    handleChangeSchool() {
      this.$refs["changeSchoolForm"].validate((v) => {
        if (v) {
          this.MultipleClues.forEach((v) => {
            this.transferSchoolAction(
              v.client_id,
              this.changeSchoolFormData.school_id,
              this.changeSchoolFormData.reason
            );
          });
        } else {
          return;
        }
      });
    },
    transferSchoolAction(client_id, re_school_id, note) {
      storeAdmissionCue
        .transferSchoolAction({
          client_id,
          re_school_id,
          note,
          school_id: this.$store.state.SCHOOL_ID,
        })
        .then((res) => {
          const { code, msg } = res.data;
          this.$message({
            message: msg,
            type: code === 200 ? "success" : "error",
          });
          if (res.data.code === 200) {
            this.updateList();
            this.changeSchoolVisible = false;
          }
        });
    },
    // 获取转校学校列表
    getAllSchoolApi() {
      storeAdmissionCue.getAllSchoolApi({}).then((res) => {
        this.changeSchoolFormData.schoolList = res.data.data.list;
      });
    },
    updateList() {
      this.getInvalidClientList();
    },
    // 无效客户管理表格数据
    getInvalidClientList() {
      var $source = this.selectForm.source;
      if ($source == this.$t("Losscustomermanage.an")) {
        $source = "";
      }
      storeLosscustomerManage
        .getInvalidClientList({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          // 非必须传
          client_isinvalidreview: this.currentIndex,
          client_source: $source,
          keyword: this.selectForm.keyword,
          invalidnote_code: this.selectForm.invalidnote_code,

          invalid_starttime: this.selectForm.invaTime
            ? this.selectForm.invaTime[0]
            : "",
          invalid_endtime: this.selectForm.invaTime
            ? this.selectForm.invaTime[1]
            : "",

          create_starttime: this.selectForm.rangeTime
            ? this.selectForm.rangeTime[0]
            : "",
          create_endtime: this.selectForm.rangeTime
            ? this.selectForm.rangeTime[1]
            : "",
          client_intention_maxlevel:
            this.selectForm.client_intention_maxlevel || "",
          ishaveaudition: this.selectForm.ishaveaudition,
        })
        .then((res) => {
          //
          this.tableData = res.data.data.list;
          this.dataNumber = parseInt(res.data.data.allnum);

          var Columns = res.data.data.field;
          this.$Tool.setStorage(`getInvalidClientList${this.currentIndex}`, Columns);
          if (
            JSON.parse(
              localStorage.getItem(`showGetInvalidClientListColumns${this.currentIndex}`)
            )
          ) {
            Columns = JSON.parse(
              localStorage.getItem(`showGetInvalidClientListColumns${this.currentIndex}`)
            );
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.columns.forEach((v) => {
            if (v.prop == "client_tag") {
              this.$set(v, "istag", true);
              this.$set(v, "width", "220px");
            }
          });
          this.optionscaozuo.loading = false;
          if (res.data.code !== 200) {
            this.optionscaozuo.errortip = res.data.msg;
          }

          var arr = [];
          var arr2 = [];
          Columns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0",
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
        });
    },
    // 获取招生渠道类型
    getSource() {
      storeLosscustomerManage
        .getSource({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.SchoolsourceOption = res.data.data.list;
          this.SchoolsourceOption.unshift({
            frommedia_id: "",
            frommedia_name: this.$t("Losscustomermanage.an"),
          });
        });
    },
    // 主管审核
    lossInvalidExamineAction() {
      storeLosscustomerManage
        .lossInvalidExamineAction({
          client_id: this.customerId,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            if (this.postbe_crmlevel == "1") {
              if (this.current == 0) {
                this.getInvalidClientList("0");
              } else {
                this.getInvalidClientList("1");
              }
            } else {
              this.getInvalidClientList("1");
            }
            this.ReviewVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getInvalidClientList();
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getInvalidClientList();
    },
    // 无效客户管理->转为招生有效名单
    changeLossClientData() {
      (() => {})(this.MultipleClues);
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeLosscustomerManage
        .toEffectiveAction({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: arrMultiple,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getInvalidClientList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    changeLossClientTmkApi() {
      (() => {})(this.MultipleClues);
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push({ client_id: item.client_id });
      });
      storeLosscustomerManage
        .changeLossClientTmkApi({
          moduletype: -2,
          clients_json: JSON.stringify(arrMultiple),
        })
        .then((res) => {
          const { code, msg } = res.data;
          if (code === 200) {
            this.visible = false;
            this.$message.success(msg);
            this.getInvalidClientList();
          } else {
            this.$message.error(msg);
          }
        });
    },
    // 无效客户管理->转为意向客户
    changeLossIntentionData() {
      var arrMultiple = [];
      this.MultipleClues.forEach((item) => {
        arrMultiple.push(item.client_id);
      });
      storeLosscustomerManage
        .changeLossIntention({
          marketer_id: this.marketer_id,
          token: this.token,
          client_id: arrMultiple,
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getInvalidClientList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
    },
    //跟班试听
    leaning() {
      this.leaningVisible = true;
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeInvitationauditionmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeInvitationauditionmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeInvitationauditionmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getAuditionData(this.pagenum, "");
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      // this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息
      this.showSliderBoxSee = true;
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      // v.client_id=this.followFormid;
      (() => {})(v);
      storeInvitationauditionmanage.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getAuditionData(this.pagenum, "");
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },

    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        //  this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },

    handleClose(done) {
      this.$confirm(this.$t("Losscustomermanage.ao"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.getInvalidClientList();
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.getInvalidClientList();
    },
    handleSelectionChange(val) {
      this.MultipleClues = val;
      this.buttonHide = val.length > 0;

      this.$nextTick(() => {
        if (this.$refs["auto_height_table"]) {
          this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
            this.$refs.auto_height_table.getBoundingClientRect().top + 95
          );
        }
      });
    },
    // tab切换
    addClass: function (index) {
      this.current = index;
      this.currentPage = 1;
      if (index == 0) {
        this.getInvalidClientList("0");
      } else {
        this.getInvalidClientList("1");
      }
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let $source = this.selectForm.source;
      if ($source == this.$t("Losscustomermanage.an")) {
        $source = "";
      }
      params_str = `&client_source=${$source}&invalidnote_code=${
        this.selectForm.invalidnote_code
      }&ishaveaudition=${
        this.selectForm.ishaveaudition
      }&client_intention_maxlevel=${
        this.selectForm.client_intention_maxlevel || ''
      }&invalid_starttime=${
        this.selectForm.invaTime ? this.selectForm.invaTime[0] : ""
      }&invalid_endtime=${
        this.selectForm.invaTime ? this.selectForm.invaTime[1] : ""
      }&create_starttime=${
        this.selectForm.rangeTime ? this.selectForm.rangeTime[0] : ""
      }&create_endtime=${
        this.selectForm.rangeTime ? this.selectForm.rangeTime[1] : ""
      }&keyword=${this.selectForm.keyword}&client_isinvalidreview=${
        this.currentIndex
      }`;

      let url = storeLosscustomerManage.getInvalidClientList1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("losscustomerManage.less");
.losscustomerManage {
  height: 100vh;
  font-size: 20px;
}
</style>

<style lang="less" scoped>
.content-nav--head {
  padding: 0px 20px 0px 0px;
  .filter-condition li {
    padding: 0px 20px;
    position: relative;
    .tag-label {
      position: relative;
    }
    .tag-num {
      position: absolute;
      top: -10px;
      left: 100%;
      background-color: red;
      color: #fff;
      height: 20px;
      padding: 0 8px;
      border-radius: 20px;
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      white-space: nowrap;
    }
  }
}
</style>
